namespace advisorop.domains {
    "use strict";
    export interface ILOV {
        id?: number;
        lovType?: number;
        name?: string;
        value?: number;
        ordNo?: number;
        extra1?: string;
        extra2?: string;
        extra3?: string;
        parentId?: number;
    }

    export interface IInvestmentModel {
        id?: number;
        name?: string;
        ordNo?: number;
        managerFee?: number;        
    }

    export class InvestmentModel implements IInvestmentModel {
        id: number;
        name: string;
        ordNo: number;
        managerFee: number;
    }

    export interface IFee {
        id?: number;
        name?: string;
        ordNo?: number;
        percentage?: number;
    }
    
    export interface IOtherProposalFee {
        //platformFee?: IFee;
        //custodianFee?: Array<IFee>;
        advisorFee?: IFee;
    }
    
    export interface IRiskTolerance {
        id?: number;
        name?: string;
    }

    export interface ITargetAssetAllocation {
        id?: number;
        riskToleranceId?: number;
        name?: string;
        percentage?: number;
        riskTolerance?: IRiskTolerance;
    }

}